<template>
    <div class="modal" id="modal-contact" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-teal text-white font-bold">
                    Address Book
                </div>
                <div class="modal-body bg-white">
                    <button @click="openCompanyContactModal()" type="button"
                            class="mx-1 py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline" style="margin-right: 44% !important;">Company Address Book</button>
                    <div class="flex justify-end mb-3">
                        <input ref="filter" type="search"
                               class="bg-grey-lighter text-grey-darkest w-2/6 focus:outline-none p-2 rounded-full ml-3 text-sm"
                               placeholder="Search by name or email..." @input="debounceFilter" v-model="search">
                    </div>
                    <div class="table-responsive">
                        <table v-if="!loading && filteredList.length > 0" class="text-left w-full border-collapse">
                        <thead>
                            <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light"></th>
                            <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">Name</th>
                            <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">Email</th>
                            <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">Phone Number</th>
                        </thead>
                        <tbody v-for="(contact, index) in filteredList" :key="index + '-' + contact.email" class="bg-grey-lightest">
                            <tr>
                                <td class="pl-3 py-2 text-grey-darkest text-xs">
                                    <input type="checkbox" name="emails" :value="contact.email" id="" v-model="selected_emails">
                                </td>
                                <td class="pl-3 py-2 text-grey-darkest text-xs hidden md:table-cell">{{contact.name}}</td>
                                <td class="pl-3 py-2 text-grey-darkest text-xs">{{contact.email}}</td>
                                <td class="pl-3 py-2 text-grey-darkest text-xs hidden md:table-cell">{{contact.phone}}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                    <div v-if="pagination.data.total > pagination.data.per_page && this.exchange && !loading" class="flex justify-center mt-3">
                        <b-pagination
                            @change="goToPage"
                            v-model="pagination.data.current_page"
                            :total-rows="pagination.data.total"
                            :per-page="pagination.data.per_page"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last"
                        >
                        </b-pagination>
                    </div>
                    <div class="flex justify-center my-3" v-if="!loading && filteredList.length === 0 && contacts.length > 0">
                        <div class="alert alert-danger" role="alert">
                            No contact was found!
                        </div>
                    </div>
                    <div class="flex justify-center my-3" v-if="!loading && filteredList.length === 0 && contacts.length === 0">
                        <div class="alert alert-danger" role="alert">
                            No contacts found! <span class="hidden lg:inline">
                            Please go to your <a href="/settings">settings</a>, and disconnect your email under the External Email area. Then, reconnect your email.
                            </span>
                        </div>
                    </div>
                    <div class="flex justify-center my-3" v-if="loading">
                        <i class="fa  fa-2x fa-spinner fa-spin text-teal"></i>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary" @click.prevent="apply()">
                        Apply
                    </button>
                    <button class="btn btn-link" type="reset" data-dismiss="modal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'email-contacts-modal',
    props:['exchange','externalEmailService'],
    data() {
        return {
            contacts: [],
            filteredList: [],
            search: '',
            loading: false,
            filter: null,
            selected_emails: [],
            type: '',
            page: 1,
            pagination:{
                data: [],
                meta: {},
                links: {},
            }
        }
    },

    methods: {
        goToPage(page) {
            console.log('go to page')
            this.page = page;
            this.open(this.type);
        },
        open(type) {
            $(this.$el).modal('show');
            this.loading = true;
            this.type = type;
            this.selected_emails= [];
            this.page= 1;
            // if (this.contacts.length > 0) {
            //     this.loading = false;
            //     return;
            // }
            axios.get(route('external-email.contacts', {page: this.page, forProposal: null}))
                .then( (data) => {
                    if(data.data.message){
                        this.contacts     = '';
                        this.filteredList = '';
                        this.loading      = false;
                    }else{
                        if (this.exchange){
                            if(this.externalEmailService && this.externalEmailService === "nylas") {
                                this.contacts     = data.data;
                                this.filteredList = data.data;
                            }else{
                                this.contacts     = data.data.data;
                                this.filteredList = data.data.data;
                                this.pagination = data;
                            }
                        }else {
                            this.contacts     = data.data;
                            this.filteredList = data.data;
                        }
                        this.loading      = false;
                    }
                }).catch(error => {
                    if (error.reponse.status == 502) {
                        this.open();
                    }
                });
        },
        close(){
            $(this.$el).modal('hide');
        },

        apply()
        {
            $(this.$el).modal('hide');
            if(this.type === 'cc') {
                this.$emit('set-emails', [this.selected_emails, 'cc'] );
            } else {
                this.$emit('set-emails', [this.selected_emails, 'to']);
            }
        },

        debounceFilter: _.debounce(function(e) {
            if(e.target.value){
                this.filteredList = _.filter(this.contacts, contact => {
                    return contact.name != null && (contact.name.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1 ||
                        contact.email.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1);
                });
            }else{
                this.filteredList = this.contacts
            }
        }, 300),

        openCompanyContactModal(){
            Bus.$emit('openCompanyContactModalEmail',this.type);
        }
    }
}
</script>
